import { useIdleTimer } from "react-idle-timer";

function TimeoutComponent(navigate) {

	const onIdle = () => {
		// Redirigez l'utilisateur vers la route par défaut
		navigate("/");
	};

	useIdleTimer({
		onIdle,
		timeout: 3 * 60 * 1000, // 3 minute en millisecondes
	});
}

export default TimeoutComponent;